/**
 * product-campaign.js — MUARACHA Campaign PDP
 * Scoped to .product-campaign. No global side effects.
 * Handles: carousel, variant selection, price update, ATC, accordions.
 */

(function() {
  'use strict';

  const CAMPAIGN_SELECTOR = '.product-campaign';

  function init() {
    const root = document.querySelector(CAMPAIGN_SELECTOR);
    if (!root) return;

    const slidesContainer = root.querySelector('[data-media-container]');
    const slides = root.querySelectorAll('.product-campaign__slide');
    const prevBtn = root.querySelector('.product-campaign__arrow--prev');
    const nextBtn = root.querySelector('.product-campaign__arrow--next');
    const counterCurrent = root.querySelector('.product-campaign__counter-current');
    const counterTotal = root.querySelector('.product-campaign__counter-total');
    const expandBtn = root.querySelector('.product-campaign__expand');
    const variantThumbs = root.querySelectorAll('.product-campaign__variant-thumb');
    const atcBtn = root.querySelector('[data-add-to-cart]');
    const atcText = root.querySelector('[data-atc-text]');
    const sizeChartBtn = root.querySelector('.product-campaign__size-chart-btn');
    const variantSelect = root.querySelector('[data-variant-select]');
    const priceEl = root.querySelector('.product-campaign__price-current');
    const comparePriceEl = root.querySelector('.product-campaign__price-compare');
    const form = root.querySelector('[data-product-form]');
    const optionSelectors = root.querySelectorAll('[data-option-selector]');
    const stickyAtcBtn = root.querySelector('[data-sticky-atc-btn]');
    const stickyAtcText = root.querySelector('[data-sticky-atc-text]');

    // ================================================================
    // 1. CAROUSEL
    // ================================================================
    let currentSlide = 0;
    const totalSlides = slides.length;

    if (counterTotal) {
      counterTotal.textContent = totalSlides;
    }

    function goToSlide(index) {
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;
      currentSlide = index;

      if (slidesContainer) {
        slidesContainer.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      }

      if (counterCurrent) {
        counterCurrent.textContent = currentSlide + 1;
      }

      slides.forEach(function(slide, i) {
        slide.classList.toggle('is-active', i === currentSlide);
      });
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToSlide(currentSlide - 1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function(e) {
        e.preventDefault();
        goToSlide(currentSlide + 1);
      });
    }

    // Touch swipe + double-tap fullscreen
    var touchStartX = 0;
    var touchEndX = 0;
    var touchStartY = 0;
    var touchEndY = 0;
    var lastTapTime = 0;
    var swipeCarousel = slidesContainer || root.querySelector('.product-campaign__carousel');

    if (swipeCarousel) {
      swipeCarousel.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        touchStartY = e.changedTouches[0].screenY;
        touchEndX = touchStartX;
        touchEndY = touchStartY;
      }, { passive: true });

      swipeCarousel.addEventListener('touchmove', function(e) {
        touchEndX = e.changedTouches[0].screenX;
        touchEndY = e.changedTouches[0].screenY;
      }, { passive: true });

      swipeCarousel.addEventListener('touchend', function(e) {
        var dx = Math.abs(touchEndX - touchStartX);
        var dy = Math.abs(touchEndY - touchStartY);

        // Swipe
        if (dx > 50 && dx > dy) {
          if (touchEndX < touchStartX) {
            goToSlide(currentSlide + 1);
          } else {
            goToSlide(currentSlide - 1);
          }
          return;
        }

        // Double-tap → fullscreen
        if (dx < 20 && dy < 20) {
          var now = Date.now();
          if (now - lastTapTime < 350 && lastTapTime > 0) {
            if (expandBtn) expandBtn.click();
          }
          lastTapTime = now;
        }
      }, { passive: true });
    }

    // ================================================================
    // 2. VARIANT THUMBNAIL → SYNC CAROUSEL
    // ================================================================
    variantThumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        variantThumbs.forEach(function(t) { t.classList.remove('is-selected'); });
        thumb.classList.add('is-selected');

        // Try to find matching media slide
        var mediaId = thumb.getAttribute('data-media-id');
        if (mediaId) {
          slides.forEach(function(slide, i) {
            if (slide.getAttribute('data-media-id') === mediaId) {
              goToSlide(i);
            }
          });
        }
      });
    });

    // ================================================================
    // 3. VARIANT SELECTION + PRICE UPDATE
    // ================================================================

    // Collect selected option values with their exact option position index
    function getSelectedOptions() {
      var result = [];
      var missing = false;
      optionSelectors.forEach(function(selector) {
        var buttons = selector.querySelectorAll('[data-option-value]');
        if (buttons.length === 0) return;
        var selected = selector.querySelector('.is-selected');
        if (selected) {
          result.push({
            index: parseInt(selected.getAttribute('data-option-index') || '0', 10),
            value: selected.getAttribute('data-option-value')
          });
        } else {
          missing = true;
        }
      });
      return { options: result, missing: missing };
    }

    // Find the variant option element that exactly matches the selected options
    function findMatchingVariantOption(selectedOptions) {
      if (!variantSelect) return null;
      var opts = variantSelect.options;
      for (var i = 0; i < opts.length; i++) {
        var opt = opts[i];
        var matches = true;
        selectedOptions.forEach(function(sel) {
          var optVal = opt.getAttribute('data-o' + sel.index) || '';
          if (optVal !== sel.value) matches = false;
        });
        if (matches) return opt;
      }
      return null;
    }

    function setAtcState(disabled, text) {
      if (atcBtn && atcText) {
        atcBtn.disabled = disabled;
        atcText.textContent = text;
      }
      if (stickyAtcBtn && stickyAtcText) {
        stickyAtcBtn.disabled = disabled;
        stickyAtcText.textContent = text;
      }
    }

    function updateVariant() {
      var sel = getSelectedOptions();

      if (sel.missing) {
        setAtcState(true, 'Select size');
        return;
      }

      var foundVariant = findMatchingVariantOption(sel.options);
      if (!foundVariant) {
        setAtcState(true, 'Select size');
        return;
      }

      variantSelect.value = foundVariant.value;

      // Price
      var price = foundVariant.getAttribute('data-price');
      var compare = foundVariant.getAttribute('data-compare');
      if (priceEl && price) priceEl.textContent = price;
      if (comparePriceEl) {
        if (compare) {
          comparePriceEl.textContent = compare;
          comparePriceEl.style.display = 'inline';
        } else {
          comparePriceEl.style.display = 'none';
        }
      }

      // ATC
      if (foundVariant.disabled) {
        setAtcState(true, 'Sold out');
      } else {
        setAtcState(false, 'Add to cart');
      }
    }

    // Size button clicks
    optionSelectors.forEach(function(container) {
      var buttons = container.querySelectorAll('[data-option-value]');
      buttons.forEach(function(btn) {
        btn.addEventListener('click', function() {
          buttons.forEach(function(b) { b.classList.remove('is-selected'); });
          btn.classList.add('is-selected');
          updateVariant();
        });
      });
    });

    // Initial state — no size selected yet
    updateVariant();

    // ================================================================
    // 4. ADD TO CART — AJAX + Prestige cart drawer via cart:change event
    // ================================================================
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();

        var submitBtn = form.querySelector('[data-add-to-cart]');
        if (submitBtn && submitBtn.disabled) return;

        var variantId = variantSelect ? variantSelect.value : null;
        if (!variantId) return;

        // Loading state
        setAtcState(true, '...');

        // Collect section IDs — CartDrawer registers its own
        var sectionsToBundle = [];
        document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        }));

        var formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');
        formData.append('on_success', 'force_open_drawer');
        if (sectionsToBundle.length > 0) {
          formData.append('sections', sectionsToBundle.join(','));
          formData.append('sections_url', Shopify.routes.root + 'variants/' + variantId);
        }

        fetch(Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
          .then(function(res) {
            if (!res.ok) throw new Error('cart/add.js ' + res.status);
            return res.json();
          })
          .then(function(addResponse) {
            return fetch(Shopify.routes.root + 'cart.js')
              .then(function(res) { return res.json(); })
              .then(function(cartData) {
                if (addResponse.sections) cartData.sections = addResponse.sections;
                // Triggers CartDrawer to refresh + open
                document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
                  bubbles: true,
                  detail: {
                    baseEvent: 'variant:add',
                    onSuccessDo: 'force_open_drawer',
                    cart: cartData
                  }
                }));
              });
          })
          .catch(function(err) {
            console.error('[MUARACHA] campaign ATC failed:', err);
          })
          .finally(function() {
            // Restore correct state for selected variant
            updateVariant();
          });
      });
    }

    // ================================================================
    // 5. ZOOM OVERLAY — fullscreen gallery with prev/next
    // ================================================================
    var zoomOverlay = root.querySelector('[data-zoom-overlay]');
    var zoomImg = root.querySelector('[data-zoom-img]');
    var zoomPrev = root.querySelector('[data-zoom-prev]');
    var zoomNext = root.querySelector('[data-zoom-next]');
    var zoomCounter = root.querySelector('[data-zoom-counter]');

    function updateZoomImage() {
      if (!zoomImg) return;
      var activeSlide = root.querySelector('.product-campaign__slide.is-active');
      var activeImg = activeSlide ? activeSlide.querySelector('img') : null;
      if (!activeImg) return;

      var src = activeImg.getAttribute('src');
      var highRes = src.replace(/w=\d+/g, 'w=1600').replace(/width=\d+/g, 'width=1600');
      zoomImg.setAttribute('src', highRes);
      zoomImg.setAttribute('alt', activeImg.getAttribute('alt') || '');
      if (zoomCounter) {
        zoomCounter.textContent = (currentSlide + 1) + ' / ' + totalSlides;
      }
    }

    function openZoom() {
      if (!zoomOverlay) return;
      updateZoomImage();
      zoomOverlay.classList.add('is-open');
      // Lock background scroll + hide sticky ATC while overlay open
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      document.body.classList.add('mua-zoom-open');
    }

    function closeZoom() {
      if (zoomOverlay) {
        zoomOverlay.classList.remove('is-open');
        zoomOverlay.classList.remove('is-zoomed');
      }
      // Restore background scroll
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
      document.body.classList.remove('mua-zoom-open');
    }

    // Click on zoom image to toggle between fit-to-screen and actual-size zoom
    if (zoomOverlay && zoomImg) {
      zoomImg.addEventListener('click', function(e) {
        e.stopPropagation();
        zoomOverlay.classList.toggle('is-zoomed');
        if (zoomOverlay.classList.contains('is-zoomed')) {
          // Center the image in the viewport
          var vw = window.innerWidth;
          var vh = window.innerHeight;
          var iw = zoomImg.naturalWidth;
          var ih = zoomImg.naturalHeight;
          zoomOverlay.scrollLeft = Math.max(0, (iw - vw) / 2);
          zoomOverlay.scrollTop = Math.max(0, (ih - vh) / 2);
        }
      });
    }

    // Click on zoom overlay background (not image) to close
    if (zoomOverlay) {
      zoomOverlay.addEventListener('click', function(e) {
        if (e.target === zoomOverlay) {
          closeZoom();
        }
      });
    }

    if (expandBtn) {
      expandBtn.addEventListener('click', function(e) {
        e.preventDefault();
        openZoom();
      });
    }

    // Close button
    var zoomClose = root.querySelector('[data-zoom-close]');

    if (zoomClose) {
      zoomClose.addEventListener('click', function(e) {
        closeZoom();
      });
    }

    // Prev / Next in zoom
    if (zoomPrev) {
      zoomPrev.addEventListener('click', function(e) {
        e.stopPropagation();
        goToSlide(currentSlide - 1);
        updateZoomImage();
      });
    }

    if (zoomNext) {
      zoomNext.addEventListener('click', function(e) {
        e.stopPropagation();
        goToSlide(currentSlide + 1);
        updateZoomImage();
      });
    }

    // Swipe in zoom overlay
    if (zoomOverlay) {
      var zTouchX = 0;
      zoomOverlay.addEventListener('touchstart', function(e) {
        zTouchX = e.changedTouches[0].screenX;
      }, { passive: true });

      zoomOverlay.addEventListener('touchend', function(e) {
        var diff = zTouchX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) {
          e.preventDefault();
          if (diff > 0) {
            goToSlide(currentSlide + 1);
          } else {
            goToSlide(currentSlide - 1);
          }
          updateZoomImage();
        }
      }, { passive: true });
    }

    // Escape key to close
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeZoom();
    });

    // ================================================================
    // 6. SIZE CHART (placeholder)
    // ================================================================
    if (sizeChartBtn) {
      sizeChartBtn.addEventListener('click', function(e) {
        e.preventDefault();
        // Phase 2: open size chart modal / page
      });
    }

    // accordions handled by Prestige accordion snippet

    // ================================================================
    // 7b. STICKY ADD-TO-CART (mobile) — show only when original out of view
    // ================================================================
    var stickyAtc = root.querySelector('[data-sticky-atc]');

    if (stickyAtc && stickyAtcBtn && atcBtn && 'IntersectionObserver' in window) {
      var isMobile = window.matchMedia('(max-width: 767px)');

      var stickyObserver = new IntersectionObserver(function (entries) {
        var entry = entries[0];

        if (!isMobile.matches) {
          stickyAtc.classList.remove('is-visible');
          return;
        }

        // Show sticky only when original ATC is out of view AND above the viewport
        // (user has scrolled past it — not when it's still below)
        var scrolledPast = atcBtn.getBoundingClientRect().bottom < 0;

        if (!entry.isIntersecting && scrolledPast) {
          stickyAtc.classList.add('is-visible');
        } else {
          stickyAtc.classList.remove('is-visible');
        }
      }, { root: null, threshold: 0 });

      stickyObserver.observe(atcBtn);

      // Hide sticky when viewport resizes to desktop
      isMobile.addEventListener('change', function () {
        if (!isMobile.matches) stickyAtc.classList.remove('is-visible');
      });

      // Sticky button triggers the real ATC form submit
      stickyAtcBtn.addEventListener('click', function () {
        atcBtn.click();
      });
    }

    // ================================================================
    // 8. REVIEW ROTATOR
    // ================================================================
    var reviews = root.querySelectorAll('.muaracha-review');
    if (reviews.length > 1) {
      var reviewIndex = 0;
      function showReview(index) {
        reviews.forEach(function(el, i) {
          el.classList.toggle('is-active', i === index);
        });
      }
      setInterval(function() {
        reviewIndex = (reviewIndex + 1) % reviews.length;
        showReview(reviewIndex);
      }, 5000);
    }
  }

  // --- Init on DOM ready ---
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section load (theme editor / AJAX)
  document.addEventListener('shopify:section:load', function(e) {
    if (e.target && e.target.querySelector(CAMPAIGN_SELECTOR)) {
      init();
    }
  });

})();
